import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PaginatorFunctions } from './paginator.functions';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {

  @Input() disabled: boolean = false;

  @Input() maxSize: number = 5;

  @Input() page: number;

  @Input() pageSize: number;

  @Input() total: number;

  @Output() onChangePage: EventEmitter<any> = new EventEmitter();

  @Input() activeClass: string = 'active';

  @Input() hideNumberButtons: boolean = false;

  totalPages: number = 0;

  pageItems: any[] = [];

  constructor() { }

  // get totalPages() {
  //   return PaginatorFunctions.buildTotalPages(this.total, this.pageSize);
  // }

  // get pageItems() {
  //   return PaginatorFunctions.BuildPages(this.page, this.totalPages, this.maxSize);
  // }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.total && changes.total.currentValue != null) ||
      (changes.pageSize && changes.pageSize.currentValue != null) ||
      (changes.page && changes.page.currentValue != null)
    ) {
      this.totalPages = PaginatorFunctions.buildTotalPages(this.total, this.pageSize);
      this.pageItems = PaginatorFunctions.BuildPages(this.page, this.totalPages, this.maxSize);
    }
  }

  handleClickFirstPage = () => {
    this.handleClick(1, this.page === 1);
  };

  handleClickPreviousPage = () => {
    this.handleClick(this.page - 1, this.page === 1);
  };

  handleClickNextPage = () => {
    this.handleClick(this.page + 1, this.page === this.totalPages);
  };

  handleClickLastPage = () => {
    this.handleClick(this.totalPages, this.page === this.totalPages);
  };

  handleClickPage = page => {
    this.handleClick(page, page === this.page);
  };

  handleClick = (page, disabled) => {
    if (!disabled && !this.disabled)
      this.onChangePage.emit({ page });
  };

}
